export enum ReportTableButtonTypesEnum {
    Download,
    Preview,
    Edit,
    Delete,
    Approve,
    Decline,
    Copy,
    Reset,
    Add,
    Cancel,
    Save
}
